import { SelectOptionType } from '@portals/ui-kit';

type TProps = {
  options: Array<SelectOptionType>;
  locale: string | Array<string>;
};

export const getOptionsType = ({ options, locale }: TProps): SelectOptionType =>
  options?.find((option) => option.value === locale) || options?.[0];
